import * as React from 'react'
import {
  Container,
  Header,
  Segment,
  Grid,
  Icon,
  Button,
  Form,
} from 'semantic-ui-react'
import { Link } from 'gatsby'

const mapAddress =
'https://www.google.com.br/maps/place/Praia+do+Flamengo,+66+-+Flamengo,+Rio+de+Janeiro+-+RJ,+22210-030/' +
'@-22.9268529,-43.173776,16z/data=!4m2!3m1!1s0x99802ab37de3fd:0x6b1b8573cd06fb43?hl=en'

const ContactInfo = () => (
  <Segment basic inverted textAlign='left' className='info'>
    <Header size='large' dividing>
      Entre em contato!
    </Header>
    <Header size='small'>
      <Icon name='building' />
      <Header.Content>
        <Link to='/'>G&A ARQUITETURA E ENGENHARIA</Link>
      </Header.Content>
    </Header>
    <Header size='small'>
      <Icon name='phone square' />
      <Header.Content>
        <a href='tel:+552122320428'>(21) 2232-0428</a>
      </Header.Content>
    </Header>
    <Header size='small'>
      <Icon name='mail' />
      <Header.Content>
        <a href='mailto:gea@geaarquitetura.com.br?subject=contato'>
          gea@geaarquitetura.com.br
        </a>
      </Header.Content>
    </Header>
    <Header size='small'>
      <Icon name='home' />
      <Header.Content>
        <a
          href={mapAddress}
          target='_blank'
        >
          PRAIA DO FLAMENGO, 66
        </a>
      </Header.Content>
    </Header>
  </Segment>
)

const ContactForm = () => (
  <Form method='POST' action='//formspree.io/gea@geaarquitetura.com.br' inverted>
    <Form.Group widths='equal'>
      <Form.Input
        fluid
        name='nome'
        type='text'
        className='form-control'
        placeholder='Nome'
        label='Nome'
      />
      <Form.Input
        fluid
        name='email'
        type='email'
        className='form-control'
        placeholder='Email'
        label='Email'
      />
    </Form.Group>
    <Form.TextArea
      name='message'
      className='form-control'
      rows='5'
      placeholder='Mensagem'
      label='Mensagem'
    />
    <Button type='submit' primary>
      ENVIAR
    </Button>
  </Form>
)

const Contact = () => (
  <div className='contact' id='contact'>
    <Container>
      <Grid
        columns='2'
        textAlign='center'
        relaxed
        stackable
        className='container'
      >
        <Grid.Row>
          <Grid.Column>
            <ContactInfo />
          </Grid.Column>
          <Grid.Column>
            <ContactForm />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  </div>
)

export default Contact
